import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Webside/layout";
import Aboutus from "./components/layout/Webside/About";
import ServicesPage from "./components/layout/Webside/Services";
import ContactPage from "./components/layout/Webside/Contact";
import Pressrelease from "./components/layout/Webside/Pressrelease";
import Dashboard from "./pages/Dashboard";
import UsersTable from "./components/layout/Dashboard/Users/Users";
import LoginPage from "./components/layout/Login";


import PrivacyPolicy from "./components/layout/Webside/privacypolicy";
import Cancellationpolicy from "./components/layout/Webside/Cancellationpolicy";
import TermsAndConditions from "./components/layout/Webside/TermsAndConditions";
import ShippingPolicy from "./components/layout/Webside/Shippingpolicy";
import RefundPolicy from "./components/layout/Webside/Refundpolicy";
import OurCertifications from "./components/layout/Webside/OurCertifications";
import WhyChooseUs from "./components/layout/Webside/WhyChooseUs";
import VerifyDriverDocuments from "./components/layout/Dashboard/Rider/VerifyDriverDocuments"



// Routes mein add k
function App() {
  return (
    <div style={{ fontFamily: "Quicksand" }}>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/About" element={<Aboutus />} />
          <Route path="/Services" element={<ServicesPage />} />
          <Route path="/Contact" element={<ContactPage />} />
          <Route path="/Pressrelease" element={<Pressrelease />} />
          <Route path="/UsersTable" element={<UsersTable />} />
            <Route path="/Login" element={<LoginPage/>} />
         
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy/>} />
            <Route path="/ShippingPolicy" element={<ShippingPolicy/>} />
            <Route path="/TermsAndConditions" element={<TermsAndConditions/>} />
            <Route path="/Cancellationpolicy" element={<Cancellationpolicy/>} />
         
         
            <Route path="/RefundPolicy" element={<RefundPolicy/>} />
            <Route path="/OurCertifications" element={<OurCertifications/>} />
            <Route path="/WhyChooseUs" element={<WhyChooseUs/>} />
            <Route path="/Dashboard/VerifyDriverDocuments" element={<VerifyDriverDocuments />} />
            
       
          
        </Routes>
      </Router>
    </div>
  );
}

export default App;


// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Layout from "./components/layout/Webside/layout";
// import Aboutus from "./components/layout/Webside/About";
// import ServicesPage from "./components/layout/Webside/Services";
// import ContactPage from "./components/layout/Webside/Contact";
// import Pressrelease from "./components/layout/Webside/Pressrelease";
// import Dashboard from "./pages/Dashboard";
// import UsersTable from "./components/layout/Dashboard/Users/Users";
// import LoginPage from "./components/layout/Login";
// import PrivacyPolicy from "./components/layout/Webside/privacypolicy";
// import Cancellationpolicy from "./components/layout/Webside/Cancellationpolicy";
// import TermsAndConditions from "./components/layout/Webside/TermsAndConditions";
// import ShippingPolicy from "./components/layout/Webside/Shippingpolicy";
// import RefundPolicy from "./components/layout/Webside/Refundpolicy";
// import OurCertifications from "./components/layout/Webside/OurCertifications";
// import WhyChooseUs from "./components/layout/Webside/WhyChooseUs";
// import VerifyDriverDocuments from "./components/layout/Dashboard/Rider/VerifyDriverDocuments"; // ✅ import

// function App() {
//   return (
//     <div style={{ fontFamily: "Quicksand" }}>
//       <Router>
//         <Routes>
//           {/* Website pages */}
//           <Route path="/" element={<Layout />} />
//           <Route path="/About" element={<Aboutus />} />
//           <Route path="/Services" element={<ServicesPage />} />
//           <Route path="/Contact" element={<ContactPage />} />
//           <Route path="/Pressrelease" element={<Pressrelease />} />
//           <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
//           <Route path="/ShippingPolicy" element={<ShippingPolicy />} />
//           <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
//           <Route path="/Cancellationpolicy" element={<Cancellationpolicy />} />
//           <Route path="/RefundPolicy" element={<RefundPolicy />} />
//           <Route path="/OurCertifications" element={<OurCertifications />} />
//           <Route path="/WhyChooseUs" element={<WhyChooseUs />} />

//           {/* Login & other pages */}
//           <Route path="/Login" element={<LoginPage />} />
//           <Route path="/UsersTable" element={<UsersTable />} />

//           {/* ====== SPECIFIC ROUTES FIRST (so they don't get caught by wildcard) ====== */}
//           <Route path="/Dashboard/VerifyDriverDocuments" element={<VerifyDriverDocuments />} />

//           {/* ====== DASHBOARD WILDCARD – all other /dashboard/* routes go here ====== */}
//           <Route path="/dashboard/*" element={<Dashboard />} />
//           {/* अगर आपका Dashboard component nested routes handle करता है, तो यह ठीक है */}
//           {/* यदि नहीं, तो आपको Dashboard के अंदर <Routes> बनाना होगा, लेकिन अभी यह work करेगा */}

//           {/* Optional: अगर कोई और route न मिले तो 404 page डाल सकते हैं */}
//         </Routes>
//       </Router>
//     </div>
//   );
// }

// export default App;